import { getRequest } from './api';

const adsPlatformApi = {
  async getCurrencies() {
    const response = await getRequest('/ads-platform/currencies');
    return response;
  },

  async getCampaignReadiness() {
    const response = await getRequest('/ads-platform/campaign-readiness');
    return response;
  },
};

export default adsPlatformApi;
